import Page from "./PageShell";

export default Page
